var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.name === "SelectPlan"
    ? _c("SelectPlan")
    : _vm.name === "Binoculars"
    ? _c("Binoculars")
    : _vm.name === "Chatbot"
    ? _c("Chatbot")
    : _vm.name === "CreditCard"
    ? _c("CreditCard")
    : _vm.name === "Instagram"
    ? _c("Instagram")
    : _vm.name === "Vector"
    ? _c("Vector")
    : _vm.name === "Whatsapp"
    ? _c("Whatsapp")
    : _vm.name === "CChatbot"
    ? _c("CChatbot")
    : _vm.name === "CInstagram"
    ? _c("CInstagram")
    : _vm.name === "CWhatsappBusiness"
    ? _c(
        "div",
        { staticClass: "whatsapp-business-billing-svg" },
        [_c("WhatsappBusinessIcon")],
        1
      )
    : _vm.name === "CWhatsapp"
    ? _c(
        "div",
        { staticClass: "whatsapp-billing-svg" },
        [_c("WhatsappIcon")],
        1
      )
    : _vm.name === "CSupsis"
    ? _c("CSupsis")
    : _vm.name === "Alipay"
    ? _c("Alipay")
    : _vm.name === "Amex"
    ? _c("Amex")
    : _vm.name === "Diners"
    ? _c("Diners")
    : _vm.name === "Maestro"
    ? _c("Maestro")
    : _vm.name === "Mastercard"
    ? _c("MasterCard")
    : _vm.name === "Visa"
    ? _c("Visa")
    : _vm.name === "AppSumo"
    ? _c("AppSumo")
    : _vm.name === "Messenger"
    ? _c("MessengerIcon")
    : _vm.name === "trendyol"
    ? _c("TrendyolIcon")
    : _vm.name === "MetaIcon"
    ? _c("MetaIcon")
    : _vm.name === "CustomerTables"
    ? _c("CustomerTables")
    : _vm.name === "ChatbotNew"
    ? _c("ChatBotNew")
    : _vm.name === "Form"
    ? _c("FormSvg")
    : _vm.name === "Automation"
    ? _c("AutomationSvg")
    : _vm.name === "Mail"
    ? _c("MailSvg")
    : _vm.name === "Tasks"
    ? _c("TaskSvg")
    : _vm.name === "WhatsappBusinessNew"
    ? _c("WhatsappBusinessNew")
    : _vm.name === "WebhookIntegration"
    ? _c("WebhookIntegration")
    : _vm.name === "ArtificialIntelligence"
    ? _c("AIAssistant")
    : _vm.name === "TelegramEntegration"
    ? _c("TelegramEntegration")
    : _vm.name === "LinkedinEntegration"
    ? _c("LinkedinIcon")
    : _vm.name === "CAiVoice"
    ? _c("CAiVoice")
    : _vm.name === "WebphoneIcon"
    ? _c("WebphoneIcon")
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }